import React, { useEffect, useState } from "react";
import "../../css/homepage.css";
import { getBalance } from "../../web3hooks/contracthooks";
import TransactionItems from "../transactionItems/transactionItems";
import { Tooltip } from "@mui/material";

const UserDashboard = ({ values }) => {
  // transactions
  const [transactions, setTransactions] = useState([]);
  const [address, setAddress] = useState("");
  const [balance, setBalance] = useState(0);

  const getBal = async () => {
    const address = await window.tronWeb.trx.getAccount();
    setAddress(address?.address);
    const balance = await window.tronWeb.trx.getBalance(address?.address);
    const bal = await window.tronWeb.fromSun(balance);
    setBalance(bal);
  };
  // useeffect
  useEffect(() => {
    setTransactions(values.transactions);
    getBal();
  }, []);

  return (
    <div className="bg-gradient-br from-[#060409] to-[#361e42] px-4">
      <div className="lg:h-48 py-3 flex items-center w-full justify-start">
        <div className=" bg-transparent rounded-sm h-fit py-2 lg:w-2/5 items-start px-4 boxes">
          <div className="space-y-4">
            <div>
              <p className="text-3xl font-bold title">DASHBOARD</p>
            </div>
          </div>
        </div>
      </div>
      <div className="lg:grid grid-cols-2 gap-6 my-9 space-y-2 lg:space-y-2">
        <div className="boxes mx-3 my-2 bg-gradient-to-r from-[#22f4fa]/60 to-[#060409] lg:h-24 py-3 flex flex-col justify-center space-y-2 px-4 rounded shadow-xl text-sm col-span-1">
          <p className=" font-medium text-white">Total Transactions</p>
          <p className="text-2xl font-semibold text-white">
            {transactions.length}
          </p>
        </div>
        <div className=" boxes mx-3 my-2 bg-gradient-to-r from-[#22f4fa]/60 to-[#060409] lg:h-24 py-3 flex flex-col justify-center space-y-2 px-4 rounded shadow-xl text-sm col-span-1">
          <p className=" font-medium text-white">Balance</p>
          <p className="text-2xl font-semibold text-white">
            {Number(balance).toFixed(2)}TRX
          </p>
        </div>
      </div>
      <div className="lg:grid grid-cols-3 h-[60vh] px-4 my-6">
        <div className="bg-[#434242] rounded-md shadow-lg col-span-2 boxes">
          <div className="py-6 px-5">
            <p className="text-lg font-semibold text-white">Total Invoice</p>
          </div>
          <div className="grid grid-cols-6 px-5 py-2 text-[13px] text-white">
            <p className="col-span-5">Transaction ID</p>
            <p className="col-span-1">Status</p>
          </div>
          <>
            <div className=" overflow-y-scroll w-full h-[50vh]  text-white">
              <div>
                {transactions.map((item, i) => (
                  <TransactionItems transaction={item} key={i} />
                ))}
              </div>
            </div>
          </>
        </div>
        <div className=" col-span-1 ml-4 flex flex-col justify-between boxes">
          <div className="h-[45%] bg-[#434242] shadow-xl rounded-sm flex flex-col">
            <p className="text-lg my-2 mx-2 font-semibold text-white flex-start">
              Wallet Address
            </p>
            <Tooltip title="click to copy">
              <button
                onClick={() => {
                  navigator.clipboard.writeText(`${address}`);
                  alert("copied to clipboard");
                }}
                className="mt-6 mx-6 p-2 truncate"
              >
                {address?.substring(0, 7)}...
                {address?.substring(address.length, address.length - 7)}
              </button>
            </Tooltip>
          </div>
          <div className="h-[45%] bg-slate-100 shadow-2xl rounded-sm"></div>
        </div>
      </div>
      <div className="h-[40vh] flex items-center justify-center">
        <p className="text-2xl font-semibold text-center">Coming soon...</p>
      </div>
    </div>
  );
};

export default UserDashboard;
